// extracted by mini-css-extract-plugin
module.exports = {"NEWSLETTER":"Newsletter_NEWSLETTER__3hqpB"};